<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    document.title = 'Пользователи'
    // console.clear()
  },
}
</script>
